import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Button, CircularProgress } from '@mui/material';
import axios from 'axios';

import meestLogo from '../../assets/logoNew.svg';
import rozetkaLogo from '../../assets/rozetka.png';
import cityLogo from '../../assets/city.png';
import portmaneIcon from '../../assets/portmaneIcon.png';
import eCheck from '../../assets/eCheck.png';
import easyPay from '../../assets/easyPay.png';
import uaPay from '../../assets/uaPay.png';
import meestIcon from '../../assets/meestIcon.png';


const ChecksPage = () => {
    const { checkId } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL_OLD}/client/check/${checkId}`);
                setData(response.data.check_data);
            } catch (error) {
                console.error('Error fetching data:', error);
                navigate('/notFound');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [checkId, navigate]);

    const handleViewReceipt = (link) => {
        window.open(link, '_blank');
    };

    const getIconByPsi = (psi) => {
        switch (psi) {
            case '1836dd7e-47aa-11e4-81a4-003048d2b473':
                return eCheck;
            case '1b8cd6d5-5fe2-11eb-80d0-000c29800ae7':
                return easyPay;
            case '8370d1c3-fa3c-11e4-ba66-003048d2b473':
                return uaPay;
            case '0593dd06-1d6e-11e8-80d0-1c98ec135261':
                return portmaneIcon;
            case 'ae469975-4598-11ee-80c0-000c2961d091':
                return cityLogo;
            case 'd50fcee4-2c4d-11ee-80bd-000c2961d091':
                return rozetkaLogo;
            default:
                return meestIcon;
        }
    };

    return (
        <Box height="100vh" bgcolor="#f5f5f5" display="flex" justifyContent="center" alignItems="center">
            <Box
                sx={{
                    width: '460px',
                    height: '150px',
                    backgroundColor: '#005096',
                    position: 'absolute',
                    top: 0,
                    display: {
                        xs: 'none',
                        sm: 'block',
                    },
                }}
            ></Box>
            <Card sx={{
                width: '420px',
                height: '94%',
                maxHeight: '100vh',
                borderRadius: '15px',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                zIndex: '100'
            }}>

                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <Box display="flex" justifyContent="center" mb={2}>
                            <img src={meestLogo} alt="Meest Logo" style={{ height: '40px', maxWidth: '100%', objectFit: 'contain' }} />
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                            <Typography variant="body1" align="left">
                                Дата
                            </Typography>
                            <Typography variant="h6" align="right" fontWeight={600}>
                                {data && data[0]?.date}
                            </Typography>
                        </Box>

                        <Box flex="1" overflow="auto">
                            {data && data.map((item, index) => (
                                <Card key={index} sx={{ mb: 2, mt: 2 }}>
                                    <CardContent>
                                        <Box display="flex" alignItems="center" mb={1}>
                                            <Box display="flex" justifyContent="center">
                                                <img src={getIconByPsi(item.psi)} alt="Icon" style={{ height: '40px', maxWidth: '100%', objectFit: 'contain' }} />
                                            </Box>

                                            <Box ml={2}>
                                                <Typography variant="body1">
                                                    Номер посилки:
                                                </Typography>
                                                <Typography variant="h6" fontWeight={600}>{item.parcel_number}</Typography>
                                            </Box>
                                        </Box>
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography variant="body1" paddingTop={1} mb={3}>
                                                Сума, ₴:
                                            </Typography>
                                            <Typography variant="body1" mb={1}>{item.summ}</Typography>
                                        </Box>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            sx={{ backgroundColor: '#0061AF', fontWeight: 600 }}
                                            onClick={() => handleViewReceipt(item.link)}
                                        >
                                            Переглянути чек
                                        </Button>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    </>
                )}
            </Card>
        </Box>
    );
};

export default ChecksPage;
